import PropTypes from 'prop-types';
import {SelectUser} from '@ozgene/gp5.components.select-user';
import {findUsers, findEnabledUsers} from 'Users/service/UserService';

export default function SelectSbsUser(props) {
  const {value, onChange, useUsername, label, showInactiveUsers, ...restProps} =
    props;
  const getUsers = async () => {
    if (showInactiveUsers) {
      return await findUsers();
    } else {
      return await findEnabledUsers();
    }
  };

  return (
    <SelectUser
      value={value}
      onChange={onChange}
      useUsername={useUsername}
      label={label}
      getEntities={getUsers}
      {...restProps}
    />
  );
}

SelectSbsUser.propTypes = {
  value: PropTypes.shape({
    firstName: PropTypes.string,
    lastname: PropTypes.string,
    username: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  useUsername: PropTypes.bool,
  label: PropTypes.string,
  showInactiveUsers: PropTypes.bool,
};

SelectSbsUser.defaultProps = {
  value: null,
  useUsername: false,
  label: 'User',
  showInactiveUsers: false,
};
